// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"198":"0844a5f4","339":"f72dcc1e","446":"2abe985a","802":"9f7466ca"}[chunkId] + ".chunk.css";
};